export default "__VITE_PUBLIC_ASSET__0d86097f__"